import { Flex } from '@aloft/toolkit-sui';

import { IndicatedValue } from '../../../components/IndicatedValue.tsx';
import { SettingsControls } from '../../../components/Settings/SettingsControls.tsx';
import { selectHasArvOption } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { EstimatedROIBanner } from '../../featureGrid/components/EstimatedROIBanner.tsx';

export const AdjustmentsModuleTitle = () => {
  const hasArvOption = useAppSelector(selectHasArvOption);
  const CostBanner = hasArvOption ? EstimatedROIBanner : IndicatedValue;

  return (
    <Flex
      marginBottom=".5rem"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <CostBanner />
      <SettingsControls />
    </Flex>
  );
};
